import { AdminBookingWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: AdminBookingWebService.Configuration
});

export default config;
